var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXrp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_7519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0703 8H25.961L19.9453 13.9562C17.7668 16.1121 14.2348 16.1121 12.0547 13.9562L6.03674 8H8.92971L13.5 12.5246C14.1659 13.1809 15.0633 13.5488 15.9983 13.5488C16.9332 13.5488 17.8306 13.1809 18.4965 12.5246L23.0703 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89258 24.5625H6L12.0547 18.5695C14.2332 16.4137 17.7652 16.4137 19.9453 18.5695L26 24.5625H23.1094L18.5 20.0012C17.8341 19.3449 16.9367 18.977 16.0018 18.977C15.0668 18.977 14.1694 19.3449 13.5035 20.0012L8.89258 24.5625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_7519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16.5625,
    fill: "white",
    transform: "translate(6 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrp);
export default __webpack_public_path__ + "static/media/XRP.96a7062c8dcee014e3f67d6d6de5623f.svg";
export { ForwardRef as ReactComponent };